// Module
var code = " <div ng-hide=attrs.id> <a class=\"btn btn-lg btn-primary\" ng-disabled=true ng-transclude></a> </div> <div ng-show=attrs.id> <div> <a class=\"button accent small radius\" ng-click=\"addItem(id, name, price, quantity, discount, data, max)\" ng-transclude></a> </div> </div> ";
// Exports
module.exports = code;